<template>
    <div class="calendar-month-wrapper" @mouseover="triggerMoreAppointment('')">
        <div class="calendar-month">
            <ol class="day-of-week">
                <li v-for="weekday in Array(7).keys()">
                    <div class="bg-light calendar-month-loader" v-if="weekday === 0">
                        <AnimatedClockIcon :is-loading="areDataLoading" v-if="areDataLoading"/>
                    </div>
                    {{ $moment().weekday(weekday).format('dddd') }}
                </li>
            </ol>
            <ol class="days-grid" v-for="(dayGroup, id) in days" :key="id">
                <li
                    v-for="(day, idDay) in dayGroup.days"
                    :key="idDay"
                    class="calendar-day"
                    @dblclick="createModal(dateTime(day, 0))"
                    @contextmenu.prevent.stop="handleClick($event, [day, 0])"
                    :class="{
                      'calendar-day--not-current': !isCurrentMonth(day),
                      'calendar-day--today': isToday(day),
                      'calendar-last-row-last-grid': idDay === dayGroup.days.length - 1 && id === days.length - 1,
                      'calendar-last-row-first-grid': idDay === 0 && id === days.length - 1,
                    }"
                >
                    <div class="row no-gutters px-2 py-1">
                        <div class="col-12 text-center font-size-sm font-weight-bold">
                            <span
                                v-if="events(day).length > 0"
                                class="text-muted"
                                style="position: absolute; left: 5px; top: 46%; transform: translateY(-50%);"
                            >
                            <i class="fe fe-book"></i>
                            {{ events(day).length }}
                        </span>
                            <button
                                :class="[ isToday(day) ? 'btn-outline-warning' : 'btn-white border-0']"
                                class="btn btn-sm btn-rounded-circle border-0 py-1"
                                @click="goToCalendarType( day )"
                            >
                                <span
                                    :class="{
                                        'text-muted': ! isCurrentMonth(day),
                                        'calendar-day--today-day-number': isToday(day)
                                    }"
                                >{{ $moment(day).format("D") }}</span>
                            </button>
                        </div>
                        <div class="col-12 custom-col position-relative text-center">
                            <event
                                class="pointer draggable"
                                :events="events(day)"
                                :list="list[day]"
                                :date="dateTime(day, day)"
                                :change="change"
                                :move="confirmMove"
                                :clickEvent="clickEvent"
                                :step="step"
                                :line-height="lineHeight"
                                :isLimited="true"
                            ></event>
                            <button
                                v-if="events(day).length > 5"
                                class="btn btn-link btn-sm text-muted"
                                :id="uniqueId(day)"
                                @mouseenter="triggerMoreAppointment(day)"
                            >
                                {{ $tc('loadAppointment', (events(day).length - 4)) }}
                            </button>
                        </div>
                    </div>
                    <b-popover
                        :target="uniqueId(day)"
                        triggers="manual"
                        placement="auto"
                        v-if="events(day).length > 5"
                        boundary="window"
                        customClass="calendar-day--popover"
                    >
                        <event
                            class="pointer draggable"
                            :events="events(day)"
                            :list="list[day]"
                            :date="dateTime(day, day)"
                            :change="change"
                            :move="confirmMove"
                            :clickEvent="clickEvent"
                            :step="step"
                            :line-height="lineHeight"
                            :isLimited="false"
                        ></event>
                    </b-popover>
                </li>
            </ol>
        </div>

        <vue-simple-context-menu
            element-id="calendarMonthlyContextMenuID"
            :options="contextMenuOptions"
            ref="calendarMonthlyContextMenu"
            @option-clicked="optionClicked"
        />
    </div>
</template>

<script>
import Event from './Monthly/Event';
import VueSimpleContextMenu from "vue-simple-context-menu";
import AnimatedClockIcon from "@/components/Utils/AnimatedClockIcon.vue";

export default {
    name: "CalendarMonth",
    components: {
        Event,
        VueSimpleContextMenu,
        AnimatedClockIcon
    },
    props: {
        'areDataLoading': Boolean,
        'lineHeight': Number,
        'createModal': Function,
        'events': Function,
        'clickEvent': Function,
        'step': Number,
        'isToday': Function,
        'dateTime': Function,
        'change': Function,
        'createBlockAppointmentTimeModal': Function,
        'list': Object,
        'confirmMove': Function,
        'monthDate': Object
    },
    data() {
        return {
            isPopoverOpen: false,
            contextMenuOptions: [
                {
                    name: this.$t('New appointment'),
                    value: 'appointment',
                },
                {
                    name: this.$t('Block The Time'),
                    value: 'block'
                }
            ]
        }
    },
    computed: {
        selectedDate() {
            return this.monthDate;
        },
        days() {
            const calendar = [];
            const today = this.selectedDate;
            const startDay = today.clone().startOf('month').startOf('week');
            const endDay = today.clone().endOf('month').endOf('week');

            let date = startDay.clone().subtract(1, 'day');

            while (date.isBefore(endDay, 'day'))
                calendar.push({
                    days: Array(7).fill(0).map(() => date.add(1, 'day').clone())
                });
            return calendar;
        }
    },

    methods: {
        goToCalendarType(currentDate) {
            let date = this.$moment(currentDate);
            this.$emit('goToCalendarType', date);
        },
        isCurrentMonth(date) {
            return this.$moment(date).isSame(this.selectedDate, 'month');
        },
        triggerMoreAppointment(day) {
            if (this.isPopoverOpen)
                this.$root.$emit('bv::hide::popover');
            if (day) {
                this.isPopoverOpen = true;
                this.$root.$emit('bv::show::popover', this.uniqueId(day));
            } else {
                this.isPopoverOpen = false;
            }
        },
        uniqueId(day) {
            return 'popover-monthly-calendar-event-' + this.$moment(day).unix();
        },
        handleClick($event, item) {
            Object.defineProperty($event, 'pageX', {
                value: $event.pageX - 120,
                writable: true
            });
            Object.defineProperty($event, 'pageY', {
                value: $event.pageY - 80,
                writable: true
            });
            this.$refs.calendarMonthlyContextMenu.showMenu($event, item)
        },
        optionClicked(data) {
            const modalData = this.dateTime(data.item[0], data.item[1]);
            data.option.value === 'appointment' ? this.createModal(modalData) : this.createBlockAppointmentTimeModal(modalData)
        },
    }
};
</script>

<style lang="scss">
.calendar-month ol,
.calendar-month li {
    padding: 0;
    margin: 0;
    list-style: none;
}

.calendar-month-header {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 10px;
}

.calendar-month {
    &-wrapper {
        overflow-x: auto;
    }
    height: 100%;
    border-top: 1px solid #e7ecf3;
    border-left: 1px solid #e7ecf3;
    padding: 0;
    margin: 0;
    position: relative;
    background-color: #e7ecf3;
    border-radius: .5rem;

    &-loader {
        display: block;
        position: absolute;
        top: 14px;
        left: 10px;
    }
}

.day-of-week {
    color: #3e4e63;
    font-size: 18px;
    background-color: #fff;
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
    overflow: hidden;

    li {
        height: 51px;
        display: flex;
        justify-content: center;
        align-items: center;
        min-width: 150px;
        border-right: 1px solid #e7ecf3;
        border-bottom: 1px solid #e7ecf3;
        font-weight: 400;
    }
}

.day-of-week {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
}

.days-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
}

.calendar-last-row-first-grid {
    border-bottom-left-radius: .5rem;
}

.calendar-last-row-last-grid {
    border-bottom-right-radius: .5rem;
}

.day-of-week > * {
    padding: 5px 0;
}

.custom-col {
    min-height: 100px;
}

.days-grid {
    height: 100%;
    position: relative;
}

.calendar-day {
    position: relative;
    font-size: 16px;
    background-color: #fff;
    color: #3e4e63;
    min-width: 150px;
    border-right: 1px solid #e7ecf3;
    border-bottom: 1px solid #e7ecf3;

    &--today {
        background: #fdf3d9;
    }

    &--show-more {
        display: none;
        z-index: 2;

        .card-body {
            max-height: 135px;
            overflow-x: auto;
        }

        &::after {
            content: '';
            background: transparent;
            width: 100%;
            height: 50px;
            position: absolute;
            top: -15px;
        }
    }

    &--popover {
        .popover-body {
            max-height: 250px;
            overflow-x: auto;
            color: #3e4e63;
        }
    }
}

.calendar-day > span {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 2px;
    width: 20px;
    height: 20px;
}

.calendar-day--not-current {
}

.calendar-day--today {
    &-day-number {
        position: relative;
        top: .5px;
    }
}

.calendar-day--today > span {
    color: #fff;
    border-radius: 9999px;
    background-color: #3e4e63;
}

.card-custom.event.eventMultiple {
    width: 100%;
    position: relative !important;
}

.day-of-week > * {
    text-align: center;
    color: #95AAC9;
    font-size: 15px;
    padding: 5px 0 !important;
    font-weight: 700;
    background: #EDF2F9;
}
</style>
